import "../../../resources/fonts/fonts.css"

    export const SelectorStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["preciIMS "].join(", "),
        marginLeft: "10px",
        marginBottom: "10px"
    }
    
    export const TitleStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["Century "].join(", "),
        alignContent: "center"
    }
    export const GeneralStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["preciIMS "].join(", ")
    }

    export const ButtonStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["preciIMS "].join(", "),
        textTransform: "none",
        marginLeft: "1px",
        marginRight: "1px",
        marginBottom: "1px"
    }

    export const MainContainerBoxStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "755px"
    }

    export const ContainerBoxStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    }

    export const ContainerBoxBorderStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        border: "1px solid black"
    }

    export const RowBoxBorderStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        border: "1px solid black"
    }

    export const RowBoxToleranceStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        borderTop: "1px solid black",
        borderBottom: "1px solid black"
    }

    export const RowBoxStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    }

    export const RowBoxBaseLineStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        display: "flex",
        flexDirection: "row",
        alignItems: "baseline",
        justifyContent: "center"
    }

    export const ResultStyles = {
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["PreciIms "]
    }

    export const PaperContainerStyles = {
        width: "860px",
        height: "350px",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "10px"
    }

    export const DataGridWrapper = {
        width: "50%",
        height: 250
    }

    export const DataGridStyles = {
        //set color to white if dark mode is on or else set to black
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["PreciIms "].join(","),
        fontSize: "20px ",
        marginLeft: "10px"
    }

    export const TransparentPaperStyles = {
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "10px",
        maxHeight: "263px",
        overflow: "auto",
        backgroundColor: "transparent"
    }

    export const FavoritesPaperStyles = {
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "5px",
        marginTop: "5px",
        marginLeft: "5px",
        maxHeight: "296px",
        minHeight: "296px",
        overflow: "auto",
        backgroundColor: "transparent",
        "&::-webkit-scrollbar": {
            width: "10px"
        },
        "&::-webkit-scrollbar-track": {
            boxShadow: "inset 0 0 5px rgba(0,0,0,0.00)",
            webkitBoxShadow: "inset 0 0 10px rgba(0,0,0,0.00)"
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "grey",
            width: "10px"
        }
    }

    export const DialogStyles = {
        //set color to white if dark mode is on or else set to black
        color: (theme) =>
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["preciIMS "].join(",")
    }
